import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useState } from "react";

import BuyQtySheet from "./BuyQtySheet";

const BuyQtySheetShell = () => {
	const [view, setView] = useState("table");

	const handleViewChange = (_, nextView) => {
		if (nextView) setView(nextView);
	};

	return (
		<Stack spacing={1.5} sx={{ width: "100%" }}>
			{/* <ToggleButtonGroup
				value={view}
				exclusive
				onChange={handleViewChange}
				size="small"
				sx={{
					bgcolor: "#fff",
					"& .MuiToggleButton-root": {
						border: "1px solid rgba(0,0,0,0.14)",
						textTransform: "none",
						px: 2,
						py: 0.85,
						color: "#3a3a38",
					},
					"& .Mui-selected": {
						bgcolor: "#111110 !important",
						color: "#fff !important",
					},
				}}>
				<ToggleButton value="table">Table View</ToggleButton>
				<ToggleButton value="report">Buying Report</ToggleButton>
			</ToggleButtonGroup> */}

			<Box sx={{ width: "100%" }}>{view === "table" ? <BuyQtySheet /> : <></>}</Box>
		</Stack>
	);
};

export default BuyQtySheetShell;
